import Hyperlink from '@ingka/hyperlink';
import Text from '@ingka/text';
import designTokens from '@ingka/variables/design-tokens';
import { Trans, useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { selectAppOperation } from '../reducers/selectors';
import { useStateSelector } from '../store';

const StyledLink = styled(Hyperlink)`
  font-weight: ${designTokens.fontWeightBold};
`;

const { useExtendedHeaderText } =
  CSS_CONFIG.configurableTranslationKeys.services;

const ExtendedHeaderText: React.FC = () => {
  const { t, i18n } = useTranslation();
  const appOperation = useStateSelector(selectAppOperation);

  const showExtendedHeaderText = useExtendedHeaderText.operations.some(
    (value) => value === 'ALL_OPERATIONS' || value === appOperation,
  );

  if (!showExtendedHeaderText) {
    return null;
  }

  return (
    <>
      <Text tagName="p" textStyle="Body.M">
        {t('pages.services.mainDescription')}
      </Text>
      <Text tagName="p" textStyle="Body.M">
        <Trans
          i18n={i18n}
          i18nKey="pages.services.subDescription"
          components={[
            <StyledLink
              key="subDescriptionLink"
              url={t('pages.services.subDescriptionLink')}
              newWindow
              rel="noopener noreferrer"
            >
              SUB DESCRIPTION LINK
            </StyledLink>,
          ]}
        />
      </Text>
    </>
  );
};

export default ExtendedHeaderText;
